export * from "./OrdersHistory";
export * from "./AccountTab";
export * from "./PasswordReset";
export * from "./CartPage";
export * from "./CheckoutPage";
export * from "./ThankYouPage";
export * from "./Accueil";
export * from "./Data";
export * from "./Hosted";